var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/velocity-react/~/lodash/_Symbol.js
// module id = 315
// module chunks = 4